import { render, staticRenderFns } from "./DashboardBoxContainer.vue?vue&type=template&id=a56a57b6&scoped=true&"
import script from "./DashboardBoxContainer.vue?vue&type=script&lang=ts&"
export * from "./DashboardBoxContainer.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBoxContainer.vue?vue&type=style&index=0&id=a56a57b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56a57b6",
  null
  
)

export default component.exports